import React from 'react';
import cx from 'classnames';
// form components
import { FormInput, FormRadio } from 'components/common/form/FinalFormV2Elements';
import * as Validations from 'components/common/form/commonValidations';
import styles from '../../WeddingDetails.module.less';

type FieldSetPersonInfoProps = {
  nameKey: string;
  label: string;
};

const FieldSetPersonInfo: React.FC<FieldSetPersonInfoProps> = ({ nameKey, label }) => {
  const nameInputClasses = (isFirstName = false): string => {
    return cx(styles.inputHeight, styles.nameInputField, {
      [styles.inputSpacingHoriz]: isFirstName,
    });
  };
  const radioFieldName = `${nameKey}_wedding_role`;

  return (
    <>
      <div className={styles.nameInputContainer}>
        <FormInput
          type="text"
          name={`${nameKey}_first_name`}
          id={`${nameKey}-first-name__field`}
          placeholder="First Name"
          label={label}
          validate={[Validations.REQUIRED, Validations.MAX_LENGTH_50]}
          inline
          isRequired
          className={nameInputClasses(true)}
        />
        <FormInput
          type="text"
          name={`${nameKey}_last_name`}
          id={`${nameKey}-last-name__field`}
          placeholder="Last Name"
          validate={[Validations.REQUIRED, Validations.MAX_LENGTH_50]}
          inline
          label=" "
          className={nameInputClasses()}
        />
      </div>
      <div className={cx(styles.radioButtonsContainer, styles.radioButton)}>
        <FormRadio
          className={styles.selectorButton}
          name={radioFieldName}
          id={`${radioFieldName}--bride`}
          inline
          value="BRIDE"
          label="Bride"
        />
        <FormRadio
          className={styles.selectorButton}
          name={radioFieldName}
          id={`${radioFieldName}--groom`}
          inline
          value="GROOM"
          label="Groom"
        />
        <FormRadio
          className={styles.selectorButton}
          name={radioFieldName}
          id={`${radioFieldName}--partner`}
          inline
          value="PARTNER"
          label="Partner"
        />
      </div>
    </>
  );
};

export default FieldSetPersonInfo;



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/components/FieldSetPersonInfo/FieldSetPersonInfo.tsx